import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideEntrepriseStub } from '../../../../config/aides-entreprises';

export default function FondsDecarbonationPage() {
  const aide = getAideEntrepriseStub('fonds-decarbonation');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="entreprises" />;
}
